// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.wrapper {
  width: 90%;
  margin: 15px auto;
}

h3 {
  font-family: AppFont, sans-serif;
  text-transform: uppercase;
  text-align: center;
  margin-top: 15px;
  margin-bottom: 5px;
}

ion-input {
  --padding-start: 10px !important;
  min-height: auto !important;
  color: #fff;
}

.button-block {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 10px;
  font-size: 17px;
  font-family: AppFontMedium, sans-serif;
}

ion-icon {
  z-index: 10;
}

span {
  margin: 10px 0px;
}

.email-msg {
  margin: 0px;
  margin-bottom: 0px;
}

ion-item {
  --border-width: 0px !important;
  margin-bottom: 15px;
  border-radius: 10px;
  background: #353535;
  --min-height: 43px;
}

.number-error {
  margin: 4px 16px 0;
  font-size: 12px;
  color: var(--ion-color-danger, #eb445a);
}`, "",{"version":3,"sources":["webpack://./src/app/components/address-input-dialog/address-input-dialog.component.scss"],"names":[],"mappings":"AACA;EACE,UAAA;EACA,iBAAA;AAAF;;AAEA;EACE,gCAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;AACF;;AACA;EACE,gCAAA;EACA,2BAAA;EACA,WAAA;AAEF;;AAAA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,sCAAA;AAGF;;AADA;EACE,WAAA;AAIF;;AAFA;EACE,gBAAA;AAKF;;AAHA;EACE,WAAA;EACA,kBAAA;AAMF;;AAJA;EACE,8BAAA;EACA,mBAAA;EACA,mBAAA;EACA,mBAAA;EACA,kBAAA;AAOF;;AALA;EACE,kBAAA;EACA,eAAA;EACA,uCAAA;AAQF","sourcesContent":["\n.wrapper{\n  width: 90%;\n  margin: 15px auto;\n}\nh3 {\n  font-family: AppFont, sans-serif;\n  text-transform: uppercase;\n  text-align: center;\n  margin-top: 15px;\n  margin-bottom: 5px;\n}\nion-input {\n  --padding-start: 10px !important;\n  min-height: auto!important;\n  color: #fff;\n}\n.button-block{\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-top: 10px;\n  font-size: 17px;\n  font-family: AppFontMedium, sans-serif;\n}\nion-icon{\n  z-index: 10;\n}\nspan {\n  margin: 10px 0px;\n}\n.email-msg{\n  margin: 0px;\n  margin-bottom: 0px;\n}\nion-item {\n  --border-width: 0px !important;\n  margin-bottom: 15px;\n  border-radius: 10px;\n  background: #353535;\n  --min-height: 43px;\n}\n.number-error {\n  margin: 4px 16px 0;\n  font-size: 12px;\n  color: var(--ion-color-danger, #eb445a);\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
